import React, { useEffect, useState } from "react";
import { Select } from "antd";
const { Option } = Select;

const Dropdown = ({
  mode,
  defaultValue,
  data,
  disabled,
  placeholder,
  onChange,
  className,
}) => {
  const [value, setValue] = useState(defaultValue);
  const handleChange = (selectedValue) => {
    setValue(selectedValue);
    if (onChange) {
      onChange(selectedValue);
    }
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <Select
      placeholder={placeholder}
      disabled={disabled}
      className={
        className
          ? className
          : " flex justify-start items-center rounded-lg border-grey  lg:w-31 xl:w-40"
      }
      mode={mode === "multiple" ? "multiple" : ""}
      value={value}
      onChange={handleChange}
    >
      {data?.map((category, i) => (
        <Option key={category?.name} value={category?._id}>
          {category?.name}
        </Option>
      ))}
    </Select>
  );
};

export default Dropdown;
